module.exports = __webpack_public_path__ + "img/List.77d5ad02.svg";